module.exports = __webpack_public_path__ + "static/media/checked.117c3085.png";